/* eslint-disable no-unused-vars */
import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import moment from 'moment';
import { Acl } from 'modules/common/components/Acl';
import TransactionInformation from 'modules/common/components/TransactionInformation';
import ConfirmLabTest from 'modules/common/components/ConfirmLabTest';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { ModalContext } from 'App';
import BusinessEstablishmentList from './BusinessEstablishmentList';
import PrintOccupationalPermitModal from './PrintOccupationalPermitModal';
import EditBusinessEstablishmentModal from '../components/EditBusinessEstablishmentModal';
import AddBusinessEstablishmentModal from '../components/AddBusinessEstablishmentModal';
import RePrintOccupationalPermit from './RePrintOccupationalPermit';
import ChangeColorModal from './ChangeColorModal';
import UpdateModal from '../components/UpdateModal';
import VerifyReceipt from '../components/VerifyReceipt';
import UpdateAppointmentModal from '../components/UpdateAppointmentModal';
import ViewOR from '../components/ViewOR';
import * as action from '../action';
import * as c from '../constant';

const natureOfWorkOption = [
  { label: 'White Card (Food Handlers)', value: 'WHITE_CARD' },
  { label: 'Green Card (Non-food Handler)', value: 'GREEN_CARD' },
  {
    label: 'Pink Card (Entertainment Establishment Workers)',
    value: 'PINK_CARD',
  },
];

function ApplicationContent({
  transactionInfo,
  showTransaction,
  clearTransaction,
  startAssessment,
  isLoading,
  match,
  // onApprove,
  // onReject,
  taxpayer,
  settings,
  getSettings,
  updatedOccupationalPermitStatus,
  taxpayerProfile,
  onPrinted,
  onReceived,
  removeBusinessEst,
  permissions,
}) {
  // const [formData, setFormData] = useState({});
  const setModal = useContext(ModalContext);
  const selectedTransaction = match.params.id;

  // const onPassTest = (key, label) => (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   ConfirmLabTest(
  //     `Are you sure, do you want to mark ${label} as passed?`,
  //     (remarks) => {
  //       updatedOccupationalPermitStatus(
  //         _.get(transactionInfo, 'id'),
  //         {
  //           [`passed_${key.replace('_amount', '')}`]: 1,
  //           [`${key.replace('_amount', '')}_findings`]: remarks,
  //         },
  //         () => {
  //           showTransaction(selectedTransaction);
  //         }
  //       );
  //     },
  //     () => {},
  //     {
  //       yesLabel: 'Confirm',
  //       noLabel: 'Cancel',
  //     },
  //     true,
  //     label
  //   );
  // };

  // const onFailTest = (key, label) => (e) => {
  //   e.preventDefault();
  //   ConfirmAlert(
  //     `Are you sure, do you want to mark ${label} as failed?`,
  //     (remarks) => {
  //       updatedOccupationalPermitStatus(
  //         _.get(transactionInfo, 'id'),
  //         {
  //           [`passed_${key.replace('_amount', '')}`]: 0,
  //           [`${key.replace('_amount', '')}_findings`]: remarks,
  //         },
  //         () => {
  //           showTransaction(selectedTransaction);
  //         }
  //       );
  //     },
  //     () => {},
  //     {
  //       yesLabel: 'Confirm',
  //       noLabel: 'Cancel',
  //     },
  //     true
  //   );
  // };

  // const onStartAssessment = () => (e) => {
  //   e.preventDefault();
  //   ConfirmAlert(
  //     `Are you sure, do you want start assessment?`,
  //     () => {
  //       startAssessment(selectedTransaction, () => {
  //         showTransaction(selectedTransaction);
  //       });
  //     },
  //     () => {},
  //     {
  //       yesLabel: 'Confirm',
  //       noLabel: 'Cancel',
  //     }
  //   );
  // };

  const updateData = () => {
    showTransaction(selectedTransaction);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
    return () => {
      clearTransaction();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, [selectedTransaction]);

  const getInitials = (cString) => {
    if (cString) {
      const val = cString.replace(/\[^a-zA-Z- ]/g, '').match(/\b(\w)/g);
      const strFirstTwo = val.slice(0, 2);
      const final = strFirstTwo.join('');
      return final.toUpperCase();
    }
    return null;
  };

  const getNatureOfWork = () => {
    return (
      natureOfWorkOption.find(
        (item) => item.value === _.get(taxpayer, 'nature_of_work')
      ) || {}
    );
  };

  const computeAddtionalCopy = () => {
    let total = 0;

    if (_.get(taxpayer, 'business_establishments', []).length > 0) {
      _.get(taxpayer, 'business_establishments', []).forEach((item) => {
        total +=
          parseFloat(_.get(item, 'attributes.number_of_additional_copy', 0)) *
          115;
      });
    }

    return total;
  };

  const computeTotalAmount = () => {
    let total = 0;

    // if (_.get(taxpayer, 'nature_of_work')) {
    Object.entries(c.DEPENDENCIES)
      .filter((dep) => !!_.get(settings, `attributes.${dep[0]}`))
      .forEach((dep) => {
        total += parseFloat(_.get(settings, `attributes.${dep[0]}`));
      });
    // }

    return total + computeAddtionalCopy();
  };

  useEffect(() => {
    // if (_.get(taxpayer, 'nature_of_work'))
    getSettings('WHITE_CARD');
  }, []);

  const handleChangeColor = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ChangeColorModal data={data} id={data.id} />,
      title: 'Change Card Color',
      modalSize: 'modal-md',
    });
  };

  const updateAppointment = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateAppointmentModal
          data={data}
          id={_.get(data, 'attributes.module_id')}
          selectedTransaction={selectedTransaction}
        />
      ),
      title: 'Update Appointment',
      modalSize: 'modal-xxl',
    });
  };

  const onRegenerateOccupationalPermit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <RePrintOccupationalPermit data={data} id={data.id} />,
      title: 'Re-generate Occupational Permit',
      modalSize: 'modal-md',
    });
  };

  const onPrintOccupationalPermit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <PrintOccupationalPermitModal data={data} id={data.id} />,
      title: 'Print Occupational Permit',
      modalSize: 'modal-md',
    });
  };

  const handleOnOpenBusinessActivityModal = (item, type) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <EditBusinessEstablishmentModal info={item} type={type} />,
      title: 'Edit Business Activiy',
      modalSize: 'modal-md',
    });
  };
  const handleAddBusinessEstablishments = (e, item) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <AddBusinessEstablishmentModal transactionId={item} />,
      title: 'Add Business Activity',
      modalSize: 'modal-md',
    });
  };

  const handleOnDeleteBusinessActivity = (item) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, you want to delete this business activity?`,
      () => {
        removeBusinessEst(selectedTransaction, item, () => {
          showTransaction(selectedTransaction);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const checkAllFindingsIfPassed = () => {
    return Object.entries(c.DEPENDENCIES)
      .filter((dep) => !!_.get(settings, `attributes.${dep[0]}`))
      .every((dep) => {
        if (+_.get(taxpayer, `passed_${dep[0].replace('_amount', '')}`) === 0) {
          return false;
        }
        return true;
      });
  };

  const showVerifyReceipt = (status) => {
    return [
      'WAITING FOR PAYMENT',
      'PAID',
      'APPROVED',
      'PENDING',
      'EXPIRED REFERENCE NUMBER',
    ].includes(status);
  };

  const handleVerifyReceipt = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <VerifyReceipt
          transactionInfo={transactionInfo}
          id={selectedTransaction}
        />
      ),
      title: `Assess Payment Receipt`,
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateModal
          updateList={data.included.module.attributes}
          updateBusiness={data.included.businessEstablishments}
          id={data.id}
          moduleId={data.attributes.module_id}
        />
      ),
      title: `Update Data Information`,
      modalSize: 'modal-lg',
    });
  };

  const onViewOr = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <ViewOR id={selectedTransaction} />,
      title: `View OR`,
      modalSize: 'modal-lg',
    });
  };

  return (
    <>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        <div className="right-section-content">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3 py-3">
            <div className="col-12 px-0 mt-0 mb-1">
              {/* BORDER */}
              <div className="card border-primary">
                <div className="container-fluid py-1">
                  <div className="p-0 d-flex flex-nowrap mb-3 w-100">
                    <div className="d-flex round-image justify-content-center">
                      <h3 className="d-flex align-items-center initials mb-0">
                        {_.get(taxpayerProfile, 'photo') !==
                        '-/format/jpeg/' ? (
                          <img
                            alt="Client Profile"
                            src={_.get(taxpayerProfile, 'photo')}
                          />
                        ) : (
                          getInitials(
                            `${_.get(taxpayer, 'first_name')} ${_.get(
                              taxpayer,
                              'middle_name'
                            )} ${_.get(taxpayer, 'last_name')}`
                          )
                        )}
                      </h3>
                    </div>
                    <div className="d-flex ml-4 align-items-center">
                      <h1 className="transaction-company m-0">
                        {`${_.get(taxpayer, 'first_name') || '-'} ${
                          _.get(taxpayer, 'middle_name') || ''
                        } ${_.get(taxpayer, 'last_name') || ''} ${
                          _.get(taxpayer, 'extension_name') || ''
                        }`}
                      </h1>
                    </div>
                  </div>
                  <div className="d-flex ml-auto justify-content-end mb-3">
                    {showVerifyReceipt(
                      _.get(transactionInfo, 'attributes.transaction_status')
                    ) && (
                      <button
                        onClick={handleVerifyReceipt}
                        className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold mr-1"
                        type="button"
                      >
                        Assess Payment Receipt
                      </button>
                    )}
                    &nbsp;
                    {!_.get(taxpayer, 'permit_number') &&
                      ['PAID'].indexOf(
                        _.get(transactionInfo, 'attributes.transaction_status')
                      ) > -1 &&
                      Acl(permissions, ['GENERATE OCCUPATIONAL PERMIT']) && (
                        <button
                          type="button"
                          onClick={onPrintOccupationalPermit(transactionInfo)}
                          className="gen-btn btn btn-primary font-weight-bold"
                        >
                          PRINT OCCUPATIONAL PERMIT{' '}
                          <i className="fas fa-print" />
                        </button>
                      )}
                    {/* {['FOR ASSESSMENT', 'PENDING LAB TEST'].indexOf(
                      _.get(transactionInfo, 'attributes.transaction_status')
                    ) > -1 &&
                      +_.get(
                        transactionInfo,
                        'attributes.is_start_assessment'
                      ) === 0 &&
                      Acl(permissions, [
                        'START ASSESSMENT OCCUPATIONAL PERMIT',
                      ]) && (
                        <button
                          disabled={isLoading}
                          type="button"
                          onClick={onStartAssessment(transactionInfo)}
                          className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
                        >
                          {isLoading ? (
                            <i className="fa fa-spin fa-spinner" />
                          ) : (
                            <>
                              Start Assessment &nbsp;&nbsp;
                              <i className="fas fa-check" />
                            </>
                          )}
                        </button>
                      )} */}
                    {/* &nbsp;
                    {+_.get(
                        transactionInfo,
                        'attributes.is_start_assessment'
                      ) === 1 &&
                      Acl(permissions, ['APPROVE OCCUPATIONAL PERMIT']) && (
                        <button
                          type="button"
                          onClick={onApprove(transactionInfo)}
                          className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold mr-1"
                        >
                          {isLoading ? (
                            <i className="fa fa-spin fa-spinner" />
                          ) : (
                            <>
                              Approve <i className="fas fa-check ml-1" />
                            </>
                          )}
                        </button>
                      )}
                    &nbsp;
                    {+_.get(
                      transactionInfo,
                      'attributes.is_start_assessment'
                    ) === 1 &&
                      Acl(permissions, ['REJECT OCCUPATIONAL PERMIT']) && (
                        <button
                          type="button"
                          onClick={onReject(transactionInfo)}
                          className="gen-btn btn btn-danger font-weight-bold"
                        >
                          {isLoading ? (
                            <i className="fa fa-spin fa-spinner" />
                          ) : (
                            <>
                              Reject <i className="fas fa-times ml-1" />
                            </>
                          )}
                        </button>
                      )} */}
                    {['OCCUPATIONAL PERMIT GENERATED'].indexOf(
                      _.get(transactionInfo, 'attributes.transaction_status')
                    ) > -1 && _.get(taxpayer, 'permit_number')
                      ? Acl(permissions, [
                          'OCCUPATIONAL PERMIT TAG AS PRINTED',
                        ]) && (
                          /* eslint-disable */
                          <button
                            disabled={isLoading}
                            type="button"
                            onClick={onPrinted(transactionInfo)}
                            className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
                          >
                            {isLoading ? (
                              <i className="fa fa-spin fa-spinner" />
                            ) : (
                              <>
                                Tag as Printed &nbsp;&nbsp;
                                <i className="fas fa-check" />
                              </>
                            )}
                          </button>
                        )
                      : ''}
                    &nbsp;
                    {['PRINTED'].indexOf(
                      _.get(transactionInfo, 'attributes.transaction_status')
                    ) > -1
                      ? Acl(permissions, [
                          'OCCUPATIONAL PERMIT TAG AS RECEIVED',
                        ]) && (
                          /* eslint-disable */
                          <button
                            disabled={isLoading}
                            type="button"
                            onClick={onReceived(transactionInfo)}
                            className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
                          >
                            {isLoading ? (
                              <i className="fa fa-spin fa-spinner" />
                            ) : (
                              <>
                                Tag as Received &nbsp;&nbsp;
                                <i className="fas fa-check" />
                              </>
                            )}
                          </button>
                        )
                      : ''}
                    {_.get(taxpayer, 'permit_number') &&
                      Acl(permissions, ['REGENERATE OCCUPATIONAL PERMIT']) && (
                        <button
                          onClick={onRegenerateOccupationalPermit(
                            transactionInfo
                          )}
                          type="button"
                          className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary  btn-sm ml-1 font-weight-bold"
                        >
                          Re-Generate Occupational Permit
                        </button>
                      )}
                    {['PAID', 'PENDING'].indexOf(
                      _.get(transactionInfo, 'attributes.status')
                    ) > -1 &&
                      Acl(permissions, [
                        'OCCUPATIONAL PERMIT UPDATE APPOINTMENT',
                      ]) && (
                        <button
                          onClick={updateAppointment(transactionInfo)}
                          type="button"
                          className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary  btn-sm ml-1 font-weight-bold"
                        >
                          Update Appointment Date
                        </button>
                      )}
                    {_.get(transactionInfo, 'attributes.paid_at') &&
                      _.get(
                        transactionInfo,
                        'included.module.attributes.permit_number'
                      ) &&
                      Acl(permissions, ['OCCUPATIONAL PERMIT VIEW E-OR']) && (
                        <button
                          onClick={onViewOr}
                          type="button"
                          className="gen-btn btn btn-warning btn-sm ml-1 font-weight-bold"
                        >
                          View OR
                        </button>
                      )}
                  </div>
                  <Tabs>
                    <TabList>
                      <Tab>Transaction</Tab>
                      <Tab>Information</Tab>
                      <Tab>Findings</Tab>
                    </TabList>
                    <TabPanel>
                      <TransactionInformation
                        module="occupationalPermit"
                        transactionInfo={transactionInfo}
                        taxpayer={taxpayer}
                      />
                    </TabPanel>
                    <TabPanel>
                      <div className="col-12 p-3">
                        <div className="row justify-content-end mr-2">
                          {Acl(permissions, ['EDIT OCCUPATIONAL PERMIT']) && (
                            <button
                              disabled={isLoading}
                              type="button"
                              onClick={handleEdit(transactionInfo)}
                              className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
                            >
                              {isLoading ? (
                                <i className="fa fa-spin fa-spinner" />
                              ) : (
                                <>Edit Information</>
                              )}
                            </button>
                          )}
                        </div>
                        <table className="transaction-table table table-borderless table-sm ">
                          <tbody>
                            <tr>
                              <td className="text-dark" width="150">
                                Last Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td width="350">
                                <b>
                                  {(
                                    _.get(taxpayer, 'last_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="150">
                                Middle Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td width="350">
                                <b>
                                  {(
                                    _.get(taxpayer, 'middle_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="150">
                                First Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td width="350">
                                <b>
                                  {(
                                    _.get(taxpayer, 'first_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="150">
                                Extension Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td width="350">
                                <b>
                                  {(
                                    _.get(taxpayer, 'extension_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="150">
                                Gender
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td width="350">
                                <b>
                                  {(
                                    _.get(taxpayer, 'gender') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="150">
                                Address of applicant
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td width="350">
                                <b>
                                  {_.get(taxpayer, 'region_name') || '--'}
                                  {''}
                                  {_.get(taxpayer, 'province_name') ||
                                    '--'}{' '}
                                  {_.get(taxpayer, 'municipality_name') || '--'}{' '}
                                  {_.get(taxpayer, 'barangay_name') || '--'}{' '}
                                  {_.get(taxpayer, 'street') || '--'}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="150">
                                Telephone No.
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td width="350">
                                <b>
                                  {(
                                    _.get(taxpayer, 'telephone_number') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="150">
                                Mobile No.
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td width="350">
                                <b>
                                  {(
                                    _.get(taxpayer, 'mobile_number') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="150">
                                Date of Birth
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td width="350">
                                <b>
                                  {moment(_.get(taxpayer, 'birth_date')).format(
                                    'MM/DD/YYYY'
                                  ) || '--'}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="150">
                                Place of Birth
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td width="350">
                                <b>
                                  {(
                                    _.get(
                                      taxpayer,
                                      'place_of_birth_region_name'
                                    ) || '--'
                                  ).toUpperCase()}{' '}
                                  {(
                                    _.get(
                                      taxpayer,
                                      'place_of_birth_province_name'
                                    ) || '--'
                                  ).toUpperCase()}{' '}
                                  {(
                                    _.get(
                                      taxpayer,
                                      'place_of_birth_municipality_name'
                                    ) || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="150">
                                Civil Status
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td width="350">
                                <b>
                                  {(
                                    _.get(taxpayer, 'civil_status') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="150">
                                Highest educational attainment
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td width="350">
                                <b>
                                  {(
                                    _.get(
                                      taxpayer,
                                      'highest_educational_attainment'
                                    ) || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="150">
                                Citizenship
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td width="350">
                                <b>
                                  {_.get(taxpayer, 'citizenship_name')
                                    ? (
                                        _.get(taxpayer, 'citizenship_name') ||
                                        '--'
                                      ).toUpperCase()
                                    : '--'}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="150">
                                Institution
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td width="350">
                                <b>
                                  {(
                                    _.get(taxpayer, 'institution_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="150">
                                Nature of Work
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td width="350">
                                <b>
                                  {getNatureOfWork().label || '--'}{' '}
                                  {Acl(permissions, [
                                    'OCCUPATIONAL PERMIT CHANGE COLOR',
                                  ]) && (
                                    <button
                                      onClick={handleChangeColor(
                                        transactionInfo
                                      )}
                                      className=" btn btn-link btn-sm"
                                      type="button"
                                    >
                                      <span className="text-danger">
                                        (edit)
                                      </span>
                                    </button>
                                  )}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="150">
                                Work Description
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td width="350">
                                <b>
                                  {_.get(taxpayer, 'work_description_name') ||
                                    '--'}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="150">
                                Business Establishments
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td width="350">
                                <div className="full-group border-bottom p-2">
                                  <div className="form-row border-light">
                                    <BusinessEstablishmentList
                                      formData={taxpayer}
                                      handleOnOpenBusinessActivityModal={
                                        handleOnOpenBusinessActivityModal
                                      }
                                      handleOnDeleteBusinessActivity={
                                        handleOnDeleteBusinessActivity
                                      }
                                      readOnly
                                    />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            {Acl(permissions, [
                              'OCCUPATIONAL PERMIT MANAGE BUSINESS ESTABLISHMENTS',
                            ]) && (
                              <tr>
                                <td width="150" className="text-dark" />
                                <td className="text-dark" width="1" />
                                <td className="text-dark" width="150">
                                  <button
                                    onClick={(e) => {
                                      handleAddBusinessEstablishments(
                                        e,
                                        selectedTransaction
                                      );
                                    }}
                                    className="btn btn-sm btn-primary cms-bg-color-primary cms-outline-primary "
                                    type="button"
                                  >
                                    Add Business Establishments
                                  </button>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div className="p-3">
                        <div className="full-group">
                          {_.get(taxpayer, 'nature_of_work') !== '' && (
                            <>
                              <div className="full-group border-bottom p-2">
                                <div className="form-row justify-content-between">
                                  <div className="form-input-group col-12 col-md-2 border-right">
                                    <label
                                      htmlFor="last_name"
                                      className="full-label mb-0"
                                    >
                                      <b>Description</b>
                                    </label>
                                  </div>
                                  <div className="form-input-group col-12 col-md-2 d-flex justify-content-center">
                                    <label
                                      htmlFor="first_name"
                                      className="full-label mb-0"
                                    >
                                      <b>AMOUNT</b>
                                    </label>
                                  </div>
                                </div>
                              </div>
                              {Object.entries(c.DEPENDENCIES)
                                .filter(
                                  (dep) =>
                                    !!_.get(settings, `attributes.${dep[0]}`)
                                )
                                .map((dep) => {
                                  const label = (_.get(dep, '1.label') || '')
                                    .toLowerCase()
                                    .replace(' ', '_')
                                    .replace(' ', '_');
                                  const findings = _.get(
                                    taxpayer,
                                    `${label}_findings`
                                  );
                                  const isPassed = +_.get(
                                    taxpayer,
                                    `passed_${label}`
                                  );

                                  return (
                                    <div
                                      key={dep[0]}
                                      className="full-group border-bottom p-2"
                                    >
                                      <div className="form-row form-row justify-content-between">
                                        <div className="form-input-group col-12 col-md-2 border-right">
                                          <label
                                            htmlFor="first_name"
                                            className="full-label mb-0"
                                          >
                                            <b>{dep[1].label}</b>
                                          </label>
                                        </div>
                                        <div className="form-input-group col-12 col-md-2">
                                          <span className="full-input text-uppercase d-flex justify-content-end">
                                            {_.get(
                                              settings,
                                              `attributes.${dep[0]}`
                                            ).toLocaleString(undefined, {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            })}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                              {/* <div className="full-group border-bottom p-2">
                                <div className="form-row">
                                  <div className="form-input-group col-12 col-md-10 border-right d-flex justify-content-end">
                                    <label
                                      htmlFor="first_name"
                                      className="full-label mb-0"
                                    >
                                      <b>Additional Copy (P115 per copy)</b>
                                    </label>
                                  </div>
                                  <div className="form-input-group col-12 col-md-2">
                                    <span className="full-input text-uppercase d-flex justify-content-end">
                                      {computeAddtionalCopy().toLocaleString(
                                        undefined,
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )}
                                    </span>
                                  </div>
                                </div>
                              </div> */}
                              <div className="full-group p-2">
                                <div className="form-row">
                                  <div className="form-input-group col-12 col-md-10 border-right d-flex justify-content-end">
                                    <label
                                      htmlFor="first_name"
                                      className="full-label mb-0 text-right"
                                    >
                                      <b>Total</b>
                                    </label>
                                  </div>
                                  <div className="form-input-group col-12 col-md-2">
                                    <span className="full-input text-uppercase d-flex justify-content-end">
                                      {computeTotalAmount().toLocaleString(
                                        undefined,
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

ApplicationContent.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  taxpayer: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  removeBusinessEst: PropTypes.instanceOf(Function).isRequired,
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
  clearTransaction: PropTypes.instanceOf(Function).isRequired,
  startAssessment: PropTypes.instanceOf(Function).isRequired,
  // onApprove: PropTypes.instanceOf(Function).isRequired,
  // onReject: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  settings: PropTypes.instanceOf(Object).isRequired,
  getSettings: PropTypes.instanceOf(Function).isRequired,
  updatedOccupationalPermitStatus: PropTypes.instanceOf(Function).isRequired,
  taxpayerProfile: PropTypes.instanceOf(Object).isRequired,
  onPrinted: PropTypes.instanceOf(Object).isRequired,
  onReceived: PropTypes.instanceOf(Object).isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  permissions: getJson('permissions'),
  settings: _.get(api, `${c.GET_SETTINGS}.item`) || {},
  transactionInfo: _.get(api, `${c.SHOW_TRANSACTION}.item`) || {},
  taxpayerProfile:
    _.get(api, `${c.SHOW_TRANSACTION}.item.included.taxPayer.attributes`) || {},
  taxpayer:
    {
      ...(_.get(api, `${c.SHOW_TRANSACTION}.item.included.module.attributes`) ||
        {}),
      business_establishments:
        _.get(
          api,
          `${c.SHOW_TRANSACTION}.item.included.businessEstablishments`
        ) || [],
    } || {},
  isLoading:
    api.loading.indexOf(c.SHOW_TRANSACTION) > -1 ||
    // api.loading.indexOf(c.APPROVE_TRANSACTION) > -1 ||
    // api.loading.indexOf(c.REJECT_TRANSACTION) > -1 ||
    api.loading.indexOf(c.START_ASSESSMENT) > -1 ||
    api.loading.indexOf(c.TAG_AS_PRINTED) > -1 ||
    api.loading.indexOf(c.TAG_AS_RECIVED) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(ApplicationContent);
